import { setSuperUserAbilities } from '@/services/ability.service'

export default {
  manager(state) {
    return state.manager
  },
  managerAccesses(state) {
    if (state.manager && state.manager.abilities === '*') {
      return setSuperUserAbilities()
    }

    return state.manager && state.manager.abilities
  },
}
